var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import ContentLoader from 'react-content-loader';
var SkeletonLoader = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 10 : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    return (React.createElement("div", { className: "lfc-text-center lfc-w-full ".concat(className) }, __spreadArray([], __read(Array(size)), false).map(function (e, i) { return (React.createElement(ContentLoader, { speed: 1, width: '100%', height: 84, key: i, backgroundColor: "#f6f6ef", foregroundColor: "#e8e8e3" },
        React.createElement("rect", { x: "9", y: "4", rx: "0", ry: "0", width: "1330", height: "22" }),
        React.createElement("rect", { x: "18", y: "14", rx: "0", ry: "0", width: "1200", height: "6" }),
        React.createElement("rect", { x: "11", y: "33", rx: "0", ry: "0", width: "108", height: "13" }),
        React.createElement("rect", { x: "129", y: "33", rx: "0", ry: "0", width: "60", height: "13" }),
        React.createElement("rect", { x: "196", y: "33", rx: "0", ry: "0", width: "60", height: "13" }))); })));
};
export default SkeletonLoader;
//# sourceMappingURL=SkeletonLoader.js.map